import { render, staticRenderFns } from "./ChildrenInfo.vue?vue&type=template&id=740148ba&scoped=true&"
import script from "./ChildrenInfo.vue?vue&type=script&lang=js&"
export * from "./ChildrenInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenInfo.vue?vue&type=style&index=0&id=740148ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740148ba",
  null
  
)

export default component.exports